export interface Coordinates {
  lat: number;
  lng: number;
}

export interface ReverseGeocodeResponse {
  plus_code?: PlusCode;
  results: GeocodeResult[];
  status?: string;
}
export interface PlusCode {
  compound_code?: string;
  global_code?: string;
}
export interface GeocodeResult {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: Geometry;
  place_id: string;
  types: string[];
  navigation_points?: NavigationPoint[];
}
export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}
export interface Geometry {
  location: LatLng;
  location_type: 'ROOFTOP' | 'RANGE_INTERPOLATED' | 'GEOMETRIC_CENTER' | 'APPROXIMATE';
  viewport: Viewport;
  bounds?: Viewport;
}
export interface LatLng {
  lat: number;
  lng: number;
}
export interface Viewport {
  northeast: LatLng;
  southwest: LatLng;
}
export interface NavigationPoint {
  location: {
    latitude: number;
    longitude: number;
  };
}


// places models
export interface PlaceDetailsApiResponse {
  status: 'success' | 'error';
  data: PlaceDetailsData;
}
export interface PlaceDetailsData {
  html_attributions: string[];
  result: PlaceDetailsResult;
  status: 'OK' | string;
}
export interface PlaceDetailsResult {
  address_components: AddressComponent[];

  adr_address?: string;
  formatted_address: string;
  vicinity?: string;

  geometry: Geometry;

  place_id: string;
  reference?: string;

  name: string;
  types: string[];

  business_status?: 'OPERATIONAL' | 'CLOSED_TEMPORARILY' | 'CLOSED_PERMANENTLY';

  rating?: number;
  user_ratings_total?: number;

  formatted_phone_number?: string;
  international_phone_number?: string;

  opening_hours?: OpeningHours;
  current_opening_hours?: OpeningHours;

  website?: string;
  url?: string;

  plus_code?: PlusCode;

  photos?: PlacePhoto[];
  reviews?: ReviewLocation[];

  icon?: string;
  icon_background_color?: string;
  icon_mask_base_uri?: string;

  utc_offset?: number;
  wheelchair_accessible_entrance?: boolean;
}
export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}
export interface Geometry {
  location: LatLng;
  viewport: Viewport;
}
export interface LatLng {
  lat: number;
  lng: number;
}
export interface Viewport {
  northeast: LatLng;
  southwest: LatLng;
}
export interface OpeningHours {
  open_now?: boolean;
  periods?: OpeningPeriod[];
  weekday_text?: string[];
}
export interface OpeningPeriod {
  open: OpeningTime;
  close: OpeningTime;
}
export interface OpeningTime {
  day: number; // 0 = Sunday
  time: string; // "1000"
  date?: string; // present in current_opening_hours
}
export interface PlacePhoto {
  height: number;
  width: number;
  photo_reference: string;
  html_attributions: string[];
}
export interface ReviewLocation {
  author_name: string;
  author_url?: string;
  profile_photo_url?: string;

  rating: number;
  relative_time_description: string;

  language: string;
  original_language?: string;

  text: string;
  time: number;
  translated?: boolean;
}
export interface PlusCode {
  compound_code?: string;
  global_code?: string;
}


// AutoComplete Api

export interface PlacesAutocompleteApiResponse {
  status: 'success' | 'error';
  data: PlacesAutocompleteData;
}
export interface PlacesAutocompleteData {
  predictions: PlacePredictionResult[];
  status: 'OK' | string;
}
export interface PlacePredictionResult {
  description: string;
  place_id: string;
  reference?: string;

  matched_substrings?: MatchedSubstring[];
  structured_formatting?: StructuredFormatting;
  terms?: PredictionTerm[];
  types?: string[];
}
export interface MatchedSubstring {
  length: number;
  offset: number;
}
export interface StructuredFormatting {
  main_text: string;
  secondary_text?: string;

  main_text_matched_substrings?: MatchedSubstring[];
}
export interface PredictionTerm {
  offset: number;
  value: string;
}

